<template>
  <component :is="layoutComponent" :showSidebar="showSidebar">
    <div class="pt-1 ms-3" :class="blur()">
      <div v-if="network.can.invite_member" class="row">
        <div class="col-md-10 col-lg-10 col-sm-12 ps-0">
          <div role="group" :aria-label="$t('ResultMediaSection.basic-radio-toggle-button-group')" class="btn-group">
            <button
              v-for="(option, index) in currentView.options"
              :id="'btnradio'+index"
              :key="index"
              :data-test="'btnradio'+index"
              role="button"
              :for="'btnradio'+index"
              :class="defineActiveTab(currentView.model, index)"
              class="btn btn-outline-primary"
              @click="currentView.model = option.value;"
            >
              <input :id="'btnradio'+index" v-model="currentView.model" :data-test="'btnradio'+index" type="radio" name="btnradio" autocomplete="off" :value="option.value" class="btn-check" />
              {{ option.text }}
            </button>
          </div>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 pe-0" align="right">
          <router-link :to="'/networks/' + network.slug + '/members/invite-members'">
            <button id="add_new_members" data-test="add_new_members" class="btn btn-outline-primary" style="border: 2px solid;">
              {{ $t('network.member.addNewMembers') }}
            </button>
          </router-link>
        </div>
      </div>

      <div class="mt-2">
        <b-overlay rounded="sm">
          <div v-if="currentView.model != 'moderation' && network.moderation && pendingRequests.length > 0 && isModerator && !busy"
            class="alert alert-warning alert-dismissible fade show text-black fw-semibold mb-0" role="alert">
            There are {{ pendingRequests.length }} pending requests for {{ network.name }} network membership.
            Please review them by visiting {{ $t('member-moderation') }}.
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
          <div v-if="currentView.model === 'current'">
            <CurrentTab :network="network" :isAdmin="isAdmin" />
          </div>
          <div v-if="currentView.model === 'invited'">
            <InviteTab :network="network" :isAdmin="isAdmin" />
          </div>
          <div v-if="currentView.model === 'moderation'">
            <ModerationTab :network="network" :isModerator="isModerator" />
          </div>
        </b-overlay>
      </div>
      <JoinNetworkCard :show="showJoinCard" :network="network" :instance="instance" />
    </div>
  </component>
</template>
<script>
window.axios = require('axios');
import DefaultSidebarLayout from '@/views/layouts/default-sidebar/';
import JoinNetworkCard from '@/components/commons/Networks/JoinNetworkCard.vue';
import CurrentTab from './CurrentTab.vue';
import InviteTab from './InviteTab.vue';
import ModerationTab from './ModerationTab.vue';
import moment from 'moment';
import '@/lib/ag-grid';

export default {
  components: {
    DefaultSidebarLayout,
    JoinNetworkCard,
    CurrentTab,
    InviteTab,
    ModerationTab,
  },
  filters: {
    date(val) {
      return val ? moment(val).format('YYYY-MM-DD') : '';
    },
  },
  props: {
    showSidebar: {
      type: Boolean,
      default: false,
    },
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      currentView: {
        options: [
          { text: this.$t('current-members'), value: 'current', icon: 'fas fa-users' },
          { text: this.$t('invited-members'), value: 'invited', icon: 'fas fa-users-medical' },
        ],
        model: 'current',
      },
      showJoinCard: false,
      instance: '',
      pendingRequests: '',
      isAdmin: false,
      isModerator: false,
    };
  },
  computed: {
    layoutComponent() {
      if (this.noLayout) return 'NoLayout';
      return 'DefaultSidebarLayout';
    },
  },
  watch: {
    isAdmin: {
      handler: function (newVal) {
        this.isAdmin = newVal;
      }
    },
    isModerator: {
      handler: function (newVal) {
        this.isModerator = newVal;
      }
    },
    showJoinCard(newVal) {
      if (newVal == true) {
        this.$store.dispatch('setNextURL', this.$route.fullPath);
      }
    },
  },
  mounted() {
    const isSuperAdmin = this.$auth.auth && this.$auth.hasRole('super-admin');
    if (this.$auth.auth) {
      this.$bus.on('network-admin-updated', ({ network, member }) => {
        if (member.user_id === this.$auth.user.user_id && network.slug === this.network.slug) {
          this.isAdmin = (member.role_name === 'admin');
        }
      });
      this.$bus.on('network-moderator-updated', ({ network, member }) => {
        if (member.user_id === this.$auth.user.user_id && network.slug === this.network.slug) {
          this.isModerator = member.is_moderator || isSuperAdmin;
        }
      });
      this.$http
        .get('networks/' + this.network.slug + '/members')
        .then(resp => {
          const isAdminUser = resp.data.data.some(member => member.role_name === 'admin' && member.user_id === this.$auth.user.user_id);
          const isModUser = resp.data.data.some(member => member.is_moderator === true && member.user_id === this.$auth.user.user_id);
          this.isAdmin = isAdminUser || isSuperAdmin;
          this.isModerator = isModUser || isSuperAdmin;
      });
      if (this.network.can.remove_member && this.network.moderation) {
        this.busy = true;
        this.currentView.options.push({
          text: this.$t('member-moderation'),
          value: 'moderation',
          icon:'fas fa-users-gear',
        });
        this.$http
          .get('networks/' + this.network.slug + '/moderations')
          .then(resp => {
            this.pendingRequests = resp.data.filter(m => m.moderation_status === 'Pending' && m.user.email_verified_at != null);
            this.busy = false;
          });
      }
      if (!this.network.is_mine && !this.$auth.hasRole('super-admin')) {
        if (this.network.public) {
          if (this.network.moderation) {
            // public and moderated network
            if (this.network.industry_membership_expired) {
              // for user whose membership has expired
              this.instance = 'showIndustryMembershipExpiredModal';
              this.showJoinCard = true;
            } else if (this.network.is_in_moderation_queue) {
              // for users who have applied to join the moderated network
              if (this.network.join_status != 'REJECTED') {
                // for users who have applied to join the moderated network (pending status)
                this.instance = 'showPendingModerationModal';
                this.showJoinCard = true;
              } else if (this.network.join_status == 'REJECTED') {
                // for users who have applied to join the moderated network (rejected status)
                this.instance = 'showRejectedModerationModal';
                this.showJoinCard = true;
              }
            } else if (this.network.is_in_industry_moderation_queue) {
              // for industry users who have applied to join the moderated network
              if (this.network.industry_join_status != 'REJECTED') {
                // for industry users who have applied to join the moderated network (pending status)
                this.instance = 'showIndustryPendingModerationModal';
                this.showJoinCard = true;
              } else if (this.network.industry_join_status == 'REJECTED') {
                // for industry users who have applied to join the moderated network (rejected status)
                this.instance = 'showIndustryRejectedModerationModal';
                this.showJoinCard = true;
              }
            } else {
              // public and non moderated network - for users who haven't applied to join
              this.instance = 'showModerationModal';
              this.showJoinCard = true;
            }
          } else {
            // public and non moderated network
            this.instance = 'showPublicJoinModal';
            this.showJoinCard = true;
          }
        } else {
          // private network
          this.instance = 'showPrivateModal';
          this.showJoinCard = true;
        }
      }
    } else {
      // for logged out users
      this.instance = 'showLoggedOutModal';
      this.showJoinCard = true;
    }
  },
  methods: {
    blur() {
      if (!this.$auth.auth) {
        return 'blur';
      } else if (!this.network.is_mine && !this.$auth.hasRole('super-admin')) {
        return 'blur';
      } else {
        return '';
      }
    },
    defineActiveTab(model, index){
      if (model == 'current' && index==0 || model == 'invited' && index==1 || model == 'moderation' && index==2) {
        return 'active';
      }
    },
  },
};
</script>
<style>
.blur {
  color: transparent;
  text-shadow: 0 0 8px #000;
  -webkit-filter: blur(5px);
  filter: blur(5px);
  pointer-events: none !important;
}
</style>